module.exports = __webpack_public_path__ + "img/weatherpedia-pwa7.2ebbfa8f.jpg";